import { useState } from 'react'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'

export const StockEditModalOpen = ({
  children,
}: {
  children: (onClose: () => void) => React.ReactNode
}) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <PlainButtonAsLink onClick={() => setOpen(true)}>
        <PlainIcon type={iconType.PEN2} color={iconColor.COLOR_PRIMARY} width={14} height={14} />
      </PlainButtonAsLink>
      {open && children(() => setOpen(false))}
    </>
  )
}
